import { enableProdMode, importProvidersFrom } from '@angular/core';

import { HttpClient, HttpClientModule, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgxCurrencyDirective } from 'ngx-currency';
import { NgxMaskDirective, NgxMaskPipe, provideEnvironmentNgxMask } from 'ngx-mask';
import { AppRoutingModule } from './app/app-routing.module';
import { AppComponent } from './app/app.component';
import { ApiService } from './app/core/apis/util/api.service';
import { AuthUserService } from './app/core/apis/auth/auth-user.service';
import { IamService } from './app/core/apis/iam/api/api';
import { AuthService } from './app/core/apis/identific/api/auth.service';
import { CartaService } from './app/core/apis/orchestrador/api/carta.service';
import { OrdemService } from './app/core/apis/orchestrador/api/ordem.service';
import { UsuarioService } from './app/core/apis/orchestrador/api/usuario.service';
import { UserAccountsService } from './app/core/apis/user-accounts/api/api';
import { Globals } from './app/core/helpers/globals';
import { CartaOrdemBaixaService } from './app/core/service/cartas/carta-ordem-baixa.service';
import { CartaOrdemEnderecoService } from './app/core/service/cartas/carta-ordem-endereco.service';
import { CartaPadraoService } from './app/core/service/cartas/carta-padrao.service';
import { CartaRecifeService } from './app/core/service/cartas/carta-recife.service';
import { environment } from './environments/environment';
import { datadogRum } from '@datadog/browser-rum';
import packageJson from '../package.json';

// AoT requires an exported function for factories
export function httpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
  }

if (environment.production) {
  enableProdMode();
}

datadogRum.init({
  applicationId: '510a13ef-5d37-455d-acf8-2a52583aa2f0',
  clientToken: 'pub42bf904de888e0b56327515c7e1abcec',
  site: 'datadoghq.com',
  service: packageJson.name,
  env: environment.production ? 'prod' : 'uat',
  version: packageJson.version,
  sessionSampleRate: 10,
  sessionReplaySampleRate: 5,
  defaultPrivacyLevel: 'mask-user-input',
});

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(BrowserModule,
          AppRoutingModule, ReactiveFormsModule,
          MatExpansionModule, MatMenuModule, MatDialogModule,
          MatDatepickerModule,
          MatNativeDateModule, MatSelectModule,
          MatRadioModule, MatTableModule, MatButtonModule,
          MatCheckboxModule,
          MatToolbarModule,
          MatProgressSpinnerModule, MatDividerModule, MatTabsModule,
          MatPaginatorModule,
          MatAutocompleteModule, MatTooltipModule, MatInputModule, MatIconModule, MatSnackBarModule,
          FormsModule, NgxCurrencyDirective,
          HttpClientModule,
          TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: httpLoaderFactory,
                deps: [HttpClient],
            },
        }), NgxMaskDirective, NgxMaskPipe),
        OrdemService,
        ApiService,
        CartaService,
        UsuarioService,
        MatDatepickerModule,
        AuthService,
        AuthUserService,
        Globals,
        CartaPadraoService,
        CartaRecifeService,
        CartaOrdemBaixaService,
        CartaOrdemEnderecoService,
        IamService,
        UserAccountsService,
        provideEnvironmentNgxMask(),
        provideAnimations(),
        provideHttpClient(withInterceptorsFromDi()),
    ]
})
  .catch(err => console.error(err));
